import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col, Button } from 'react-bootstrap';
import { IQuoteActions } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';

interface IHomePageProps {
  actions: {
    quote: IQuoteActions;
  };
}

class HomePage extends React.Component<IHomePageProps> {

  public render() {
    return (
      <div className="front-page animated fadeIn">
        <div className="container">
          <Row>
            <Col sm={12}>
              <h2>RC Professionnelle et Garantie Financière des Intermédiaires en Assurance, Banque et Immobilier</h2>

              {/*<Button*/}
                {/*bsStyle="primary"*/}
                {/*className="get-quote-btn"*/}
                {/*onClick={this.handleGetQuote}*/}
              {/*>*/}
                {/*<FaChevronRight/>*/}
                {/*GET A QUOTE*/}
              {/*</Button>*/}
              {/*<DocumentList/>*/}
            </Col>
          </Row>
          <Row className="homepage-list">
            <Col sm={2} className="list-header">
              <span>Vous êtes*</span>
            </Col>
            <Col sm={10} className="list">
              <div>
                <ul>
                  <li>Intermédiaire en Assurance</li>
                  <li>Intermédiaire en Opérations de Banque et Services de Paiement</li>
                  <li>Démarcheur Bancaire et Financier</li>
                  <li>Agent Commercial Immobilier à titre d’activité unique</li>
                </ul>
              </div>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <p>
                *Vous remplissez les conditions légales et réglementaires correspondant à l’exercice de chaque activité
                professionnelle
              </p>
              <h3>
                Souscrivez votre assurance en ligne si votre chiffre d'affaires annuel est inférieur à 750 000 €.
              </h3>
            </Col>
          </Row>

        </div>
      </div>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    actions: {
      quote: bindActionCreators({ ...quoteActions }, dispatch),
    },
  }),
)(HomePage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/HomePage/index.tsx